import { useEffect, useState } from 'react';

const DURATION_MS = (17 * 60 + 34) * 1000;
// Shared start so every timer on the page stays in sync.
const START = Date.now();

export function useCountdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = (now - START) % DURATION_MS;
  const remaining = Math.ceil((DURATION_MS - elapsed) / 1000);
  const total = remaining >= DURATION_MS / 1000 ? DURATION_MS / 1000 : remaining;

  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  };
}
